/* filepath: /c:/Users/SIELO PRO/Documents/GitHub/Site Estacia/src/layouts/Footer/Footer.jsx */
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaWhatsapp, FaTelegram, FaTiktok } from "react-icons/fa";
import "./Footer.css";
import IntlMessages from "../../intl/IntlMessages";

const Footer = () => {
  return (
    <footer>
      <div className="footer-top">
        <Container>
          <Row className="gy-4">
            <Col md={4}>
              <h5>
                <IntlMessages id="content.ourServices" />
              </h5>
              <ul className="list-unstyled">
                <li>
                  <a href="/vision/immobilier">
                    <IntlMessages id="sections.realEstate" />
                  </a>
                </li>
                <li>
                  <a href="/vision/évènementiel">
                    <IntlMessages id="sections.eventManagement" />
                  </a>
                </li>
                <li>
                  <a href="/vision/informatique">
                    <IntlMessages id="content.itServices" />
                  </a>
                </li>
                <li>
                  <a href="/vision/telecom">
                    <IntlMessages id="content.networkTelecom" />
                  </a>
                </li>
                <li>
                  <a href="/vision/civilEngeneering">
                    <IntlMessages id="content.btp" />
                  </a>
                </li>
                <li>
                  <a href="/vision/socialPlatform">
                    <IntlMessages id="content.socialPlatform" />
                  </a>
                </li>
              </ul>
            </Col>
            <Col md={4}>
              <h5>
                <IntlMessages id="sections.quickLinks" />
              </h5>
              <ul className="list-unstyled">
                <li>
                  <a href="/apropos">
                    <IntlMessages id="sections.about" />
                  </a>
                </li>
                <li>
                  <a href="/contact">
                    <IntlMessages id="sections.contacts" />
                  </a>
                </li>
              </ul>
            </Col>
            <Col md={4}>
              <h5>
                <IntlMessages id="sections.stayConnected" />
              </h5>
              <ul className="social-icons list-unstyled">
                <li>
                  <a
                    href="https://t.me/+_yyw-0bPaVA2YTlk"
                    className="social-icon telegram"
                    aria-label="Telegram"
                  >
                    <FaTelegram />
                  </a>
                </li>
                <li>
                  <a
                    href="https://chat.whatsapp.com/D1FQpvd3ovS7XU3QXanfrb?mode=ems_copy_t"
                    className="social-icon whatsapp"
                    aria-label="WhatsApp"
                  >
                    <FaWhatsapp />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.tiktok.com/@estatiasci?_t=ZS-8u5ROFr1Zq6&_r=1"
                    className="social-icon tiktok"
                    aria-label="Tiktok"
                  >
                    <FaTiktok />
                  </a>
                </li>
                {/* <li>
                  <a
                    href="https://facebook.com"
                    className="social-icon facebook"
                    aria-label="Facebook"
                  >
                    <FaFacebookF />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com"
                    className="social-icon twitter"
                    aria-label="Twitter"
                  >
                    <FaTwitter />
                  </a>
                </li>
                <li>
                  <a
                    href="https://instagram.com"
                    className="social-icon instagram"
                    aria-label="Instagram"
                  >
                    <FaInstagram />
                  </a>
                </li>
                <li>
                  <a
                    href="https://youtube.com"
                    className="social-icon youtube"
                    aria-label="WhatsApp"
                  >
                    <FaYoutube />
                  </a>
                </li> */}
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="footer-bottom">
        <Container>
          <p className="mb-0 text-center">
            © {new Date().getFullYear()}
            <IntlMessages id="footer.copyright" />
          </p>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
